<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage
        :form-open="formOpen"
        :page-titles="pageTitles"
        :hide-button="btn"
      />
      <div id="obras">
        <div>
          <label for="example-datepicker"
            >Gere o relatório de uma ou mais obras</label
          >
          <multiselect
            v-model="obra"
            :options="obras"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :selected-label="'Selecionado'"
            :deselect-label="'Remover'"
            :select-label="'Adicionar'"
            :placeholder="
              obras.length > 0
                ? 'Selecione uma ou mais obras'
                : 'Nenhuma obra cadastrada'
            "
            label="text"
            track-by="value"
          />
        </div>
      </div>
      <div id="tipo" style="margin-top: 10px">
        <div>
          <label for="example-datepicker">Tipo relatório</label>
          <b-select v-model="tipoRelatorio">
            <b-select-option value="codigos">
              Códigos de insumos cadastrados
            </b-select-option>
            <b-select-option value="quantitativo">
              Quantitativo de insumos cadastrados
            </b-select-option>
          </b-select>
        </div>
      </div>
      <div id="calendario" style="margin-top: 10px">
        <div>
          <label for="example-datepicker">Data inicial</label>
          <b-form-datepicker
            id="example-datepicker"
            v-model="dataInicial"
            class="mb-2"
            placeholder="Data inicial"
            required
          >
            <template v-slot:button-content>
              <b-icon icon="calendar" variant="primary"></b-icon>
            </template>
          </b-form-datepicker>
        </div>
        <div>
          <label for="example-datepicker-final">Data final</label>
          <b-form-datepicker
            id="example-datepicker-final"
            v-model="dataFinal"
            class="mb-2"
            placeholder="Data final"
            required
          >
            <template v-slot:button-content>
              <b-icon icon="calendar" variant="primary"></b-icon>
            </template>
          </b-form-datepicker>
        </div>
        <b-modal
          id="rel-estoque"
          size="huge"
          title="Relatório de Estoques"
          ok-only
          :hide-footer="true"
        >
          <div v-if="tipoRelatorio === 'quantitativo'">
            <vue-html2pdf
              ref="html2Pdf"
              style="display: none"
              :show-layout="false"
              :float-layout="true"
              :enable-download="false"
              :preview-modal="false"
              :paginate-elements-by-height="1800"
              :pdf-quality="2"
              pdf-format="a4"
              pdf-orientation="portrait"
              pdf-content-width="100%"
              :html-to-pdf-options="htmlToPdfOptions"
              :manual-pagination="false"
              @beforeDownload="beforeDownload($event)"
              @hasGenerated="hasGenerated($event)"
            >
              <section slot="pdf-content">
                <div class="w-50 ml-0 mr-0 mx-auto text-center">
                  <h4>RELATÓRIO</h4>
                  <h4>QUANTITATIVO DE INSUMOS EM ESTOQUES</h4>
                </div>

                <div v-for="(item, index) in items" :key="item._id">
                  <div class="row">
                    <div class="col-2">
                      <b v-show="index === 0">Obra</b><br />
                      <span>{{ item.obra.nome }}</span>
                    </div>
                    <div class="col-1 text-center">
                      <b v-show="index === 0">Código</b><br />
                      <span>{{ item.insumo.codigo }}</span>
                    </div>
                    <div class="col-1">
                      <b v-show="index === 0">Insumo</b><br />
                      <span>{{
                        item.descricao_pai
                          ? `${item.descricao_pai} / ${item.descricao}`
                          : item.insumo.descricao
                      }}</span>
                    </div>
                    <div class="col-1">
                      <b v-show="index === 0">SubItem</b><br />
                      <span v-if="item.descricao_pai">{{
                        item.insumo.descricao
                      }}</span>
                    </div>
                    <div class="col-1 text-center">
                      <b v-show="index === 0">Qtde.</b><br />
                      <span>{{ item.qtde }}</span>
                    </div>
                    <div class="col-1 text-center">
                      <b v-show="index === 0" class="text-center">Unidade</b
                      ><br />
                      <span>{{ item.insumo.unidade }}</span>
                    </div>
                    <div class="col-2 text-center">
                      <b v-show="index === 0">Valor unitário</b><br />
                      <span v-if="item.valor_unitario !== undefined">{{
                        item.valor_unitario
                      }}</span>
                    </div>
                    <div class="col-1">
                      <b v-show="index === 0">Valor Total</b><br />
                      <span v-if="item.valor_total !== undefined">{{
                        item.valor_total
                      }}</span>
                    </div>
                    <div class="col-1">
                      <b v-show="index === 0">Estoque mínimo</b><br />
                      <b-badge
                        v-if="item.alertaEstoque"
                        variant="danger"
                        class="pl-2 pr-2 pt-1 pb-1"
                        >Estoque baixo</b-badge
                      >
                      <b-badge
                        v-if="!item.alertaEstoque"
                        variant="success"
                        class="pl-2 pr-2 pt-1 pb-1"
                        >Tem estoque</b-badge
                      >
                    </div>

                    <div class="col-2 text-center">
                      <b v-show="index === 0" class="text-center">Descrição</b
                      ><br />
                      <span>{{ item.descricao }}</span>
                    </div>
                  </div>
                </div>
              </section>
            </vue-html2pdf>
          </div>
          <div v-else-if="tipoRelatorio === 'codigos'">
            <vue-html2pdf
              ref="html2Pdf2"
              style="display: none"
              :show-layout="false"
              :float-layout="true"
              :enable-download="false"
              :preview-modal="false"
              :paginate-elements-by-height="1800"
              :pdf-quality="2"
              pdf-format="a4"
              pdf-orientation="portrait"
              pdf-content-width="100%"
              :html-to-pdf-options="htmlToPdfOptions"
              :manual-pagination="false"
              @beforeDownload="beforeDownload($event)"
              @hasGenerated="hasGenerated($event)"
            >
              <section slot="pdf-content">
                <div>
                  <div class="w-50 ml-0 mr-0 mx-auto text-center">
                    <h4>RELATÓRIO</h4>
                    <h4>CÓDIGOS DE INSUMOS EM ESTOQUES</h4>
                  </div>

                  <div v-for="(item, index) in itemsCodigos" :key="index">
                    <div class="row">
                      <div class="col-2 text-center">
                        <b v-show="index === 0">Código</b><br />
                        <span>{{ item.codigo }}</span>
                      </div>
                      <div class="col-8">
                        <b v-show="index === 0">Insumo</b><br />
                        <span>{{ item.insumo }}</span>
                      </div>
                      <div class="col-2 text-center">
                        <b v-show="index === 0" class="text-center">Unidade</b
                        ><br />
                        <span>{{ item.unidade }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </vue-html2pdf>
          </div>
          <div class="w-50 ml-0 mr-0 mx-auto text-center">
            <h4>RELATÓRIO DE ESTOQUES</h4>
          </div>
          <div v-if="tipoRelatorio === 'quantitativo'">
            <div v-for="(item, index) in items" :key="item._id">
              <div class="row">
                <div class="col-1">
                  <b v-show="index === 0">Obra</b><br />
                  <span>{{ item.obra }}</span>
                </div>
                <div class="col-1">
                  <b v-show="index === 0">Código</b><br />
                  <span>{{ item.codigo }}</span>
                </div>
                <div class="col-3">
                  <b v-show="index === 0">Insumo</b><br />
                  <span>{{ item.insumo }}</span>
                </div>
                <div class="col-1 text-center">
                  <b v-show="index === 0">Qtde.</b><br />
                  <span>{{ item.qtde }}</span>
                </div>
                <div class="col-1 text-center">
                  <b v-show="index === 0">Unidade</b><br />
                  <span>{{ item.unidade }}</span>
                </div>
                <div class="col-1 text-center" style="padding-right: 9px">
                  <b v-show="index === 0">Valor unitário</b><br />
                  <span v-if="item.valor_unitario !== undefined"
                    >{{ item.valor_unitario }}
                  </span>
                  <span v-if="!item.valor_unitario">
                    valor não cadastrado
                  </span>
                </div>
                <div class="col-1" style="padding-right: 9px">
                  <b v-show="index === 0">Valor Total</b><br />
                  <span v-if="item.valor_total !== undefined">{{
                    item.valor_total
                  }}</span>
                  <span v-else-if="!item.valor_unitario">
                    valor não cadastrado
                  </span>
                </div>
                <div class="div-estoque">
                  <b v-show="index === 0">Estoque Mínimo</b>
                  <br />
                  <span>
                    {{ item.estoqueBaixo }}
                  </span>
                </div>
                <div class="div-estoque">
                  <b v-show="index === 0">Alerta</b><br />
                  <b-badge
                    v-if="item.alertaEstoque"
                    variant="danger"
                    class="pl-2 pr-2 pt-1 pb-1"
                    >Estoque baixo</b-badge
                  >
                  <b-badge
                    v-if="!item.alertaEstoque"
                    variant="success"
                    class="pl-2 pr-2 pt-1 pb-1"
                    >Tem estoque</b-badge
                  >
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="tipoRelatorio === 'codigos'">
            <div v-for="(item, index) in itemsCodigos" :key="index">
              <div class="row">
                <div class="col-2">
                  <b v-show="index === 0">Código</b><br />
                  <span>{{ item.codigo }}</span>
                </div>
                <div class="col-6">
                  <b v-show="index === 0">Insumo</b><br />
                  <span>{{ item.insumo }}</span>
                </div>
                <div class="col-3">
                  <b v-show="index === 0">Unidade Peso/Medida</b><br />
                  <span>{{ item.unidade }}</span>
                </div>
              </div>
            </div>
          </div>

          <template v-slot:modal-header>
            <div class="ml-auto">
              <b-button
                class="mr-2"
                variant="danger"
                @click="$bvModal.hide('rel-estoque')"
                >Sair</b-button
              >
              <b-button
                variant="success"
                style="font-weight: 700"
                class="mr-2"
                @click="$refs.btnexport.$el.click()"
              >
                Exportar Excel
                <vue-excel-xlsx
                  ref="btnexport"
                  style="display: none"
                  :data="
                    tipoRelatorio === 'quantitativo'
                      ? estoqueExcel
                      : estoqueCodigosExcel
                  "
                  :columns="
                    tipoRelatorio === 'quantitativo'
                      ? excelColumns
                      : excelColumnsCodigos
                  "
                  :file-name="`Relatório de Estoque, ${new Date()
                    .toLocaleDateString()
                    .replace(/\//g, '.')} ${new Date()
                    .toLocaleTimeString()
                    .replace(/:/g, '-')}`"
                  :sheet-name="'Estoque'"
                >
                </vue-excel-xlsx>
              </b-button>
              <b-button variant="primary" @click="generateReport"
                >Imprimir</b-button
              >
            </div>
          </template>
        </b-modal>
        <b-button
          variant="success"
          style="font-weight: 700"
          @click="handleSubmit"
          >Gerar</b-button
        >
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import alertMixin from '@/src/mixins/alertMixin'
import estoqueService from '../../../../services/serviceEstoqueObra'
import EstoqueModel from '@/src/model/estoque.model'
import moment from 'moment'
import VueHtml2pdf from 'vue-html2pdf'
import formataDescricaoInsumo from '@/src/utils/formataDescricaoInsumo'
import Multiselect from 'vue-multiselect'
import serviceObra from '@/src/services/serviceObra'

export default {
  components: { Layout, HeaderPage, VueHtml2pdf, Multiselect },
  mixins: [alertMixin],
  data() {
    return {
      btn: true,
      items: [],
      itemsCodigos: [],
      tipoRelatorio: 'codigos',
      formOpen: false,
      isLoading: false,
      pageTitles: {
        title: 'Relatórios de estoque',
        subtitle: 'Selecione o início e o final da data e para gerar relatório',
      },
      dataInicial: '',
      dataFinal: '',
      estoqueExcel: [],
      estoqueCodigosExcel: [],
      htmlToPdfOptions: {
        filename: `estoque.pdf`,
        margin: [8, 10, 8, 10],
        image: {
          type: 'jpeg',
          quality: 1,
        },
        html2canvas: {
          scale: 2,
          logging: true,
          dpi: 192,
          letterRendering: true,
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'landscape',
          compressPDF: true,
        },
      },
      excelColumns: EstoqueModel.stockReportColumnsInExcel,
      excelColumnsCodigos: [
        {
          label: 'Código',
          field: 'codigo',
          format: (value) => {
            return String(value).replace(',', '.')
          },
        },
        {
          label: 'Insumo',
          field: 'insumo',
        },
        {
          label: 'Unidade',
          field: 'unidade',
        },
      ],
      obra: [],
      obras: [],
    }
  },
  created() {
    this.listaObras()
  },
  methods: {
    handleSubmit() {
      if (this.tipoRelatorio === 'codigos') {
        this.gerarCodigos()
      } else if (this.tipoRelatorio === 'quantitativo') {
        this.gerar()
      }
    },
    updateByFiliais() {
      this.listaObras().then((response) => {
        this.obra = []

        if (response) {
          if (response.data.length > 0) {
            response.data.forEach((obra) => {
              this.obra.push({ obra })
            })
          }
        }
      })
    },
    async listaObras() {
      this.isLoading = true
      if (this.$store.state.filial) {
        await serviceObra
          .list('filial', this.$store.state.filial)
          .then((response) => {
            this.obras = []
            response.data.data.forEach((obra) => {
              this.obras.push({ text: obra.nome, value: obra._id })
            })
          })
          .catch((error) => {
            this.errorMessage(error.response.data.error.message)
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        await serviceObra
          .list()
          .then((response) => {
            this.isLoading = true
            this.obras = []
            response.data.data.forEach((obra) => {
              this.obras.push({ text: obra.nome, value: obra._id })
            })
          })
          .catch((error) => {
            this.errorMessage(error.response.data.error.message)
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    gerar() {
      this.isLoading = true
      let obras = []
      if (this.obra.length > 0) {
        obras = this.obra.map((obra) => obra.value)
      }
      estoqueService
        .listByDate(
          this.dataInicial,
          this.dataFinal,
          obras,
          this.$store.state.filter,
          this.$store.state.filial
        )
        .then((res) => {
          const { data } = res.data

          this.estoqueExcel = data.map(function (element) {
            return {
              obra: `${element.obra.nome}`,
              codigo: `${element.insumo.codigo}`,
              insumo: formataDescricaoInsumo(element),
              valor_unitario: element.valor_unitario,
              valor_total: element.valor_total,
              qtde: parseFloat(element.qtde),
              alerta: element.alertaEstoque ? 'Estoque baixo' : 'Tem estoque',
              unidade: element.insumo.unidade,
              estoqueBaixo: element.insumo.estoqueBaixo,
              alertaEstoque: element.alertaEstoque,
            }
          })

          this.estoqueExcel = this.estoqueExcel.sort((a, b) => {
            if (a.obra < b.obra) {
              return -1
            }

            if (a.obra > b.obra) {
              return 1
            }

            if (a.alertaEstoque && b.alertaEstoque) {
              return 0
            }

            if (!a.alertaEstoque && !b.alertaEstoque) {
              return 0
            }

            if (a.alertaEstoque && !b.alertaEstoque) {
              return -1
            }

            if (b.alertaEstoque && !a.alertaEstoque) {
              return 1
            }

            if (parseFloat(a.codigo) < parseFloat(b.codigo)) {
              return -1
            }

            if (parseFloat(a.codigo) > parseFloat(b.codigo)) {
              return 1
            }

            if (a.insumo < b.insumo) {
              return -1
            }

            if (a.insumo > b.insumo) {
              return 1
            }

            if (parseFloat(a.qtde) < parseFloat(b.qtde)) {
              return -1
            }

            if (parseFloat(a.qtde) > parseFloat(b.qtde)) {
              return 1
            }

            if (parseFloat(a.unidade) < parseFloat(b.unidade)) {
              return -1
            }

            if (parseFloat(a.unidade) > parseFloat(b.unidade)) {
              return 1
            }

            if (parseFloat(a.valor_unitario) < parseFloat(b.valor_unitario)) {
              return -1
            }

            if (parseFloat(a.valor_unitario) > parseFloat(b.valor_unitario)) {
              return 1
            }

            if (parseFloat(a.valor_total) < parseFloat(b.valor_total)) {
              return -1
            }

            if (parseFloat(a.valor_total) > parseFloat(b.valor_total)) {
              return 1
            }

            if (a.alerta < b.alerta) {
              return -1
            }

            if (a.alerta > b.alerta) {
              return 1
            }

            return 0
          })
          this.items = this.estoqueExcel
          this.$bvModal.show('rel-estoque')
          this.isLoading = false
        })
        .catch((err) => {
          this.errorMessage(err.message)
          this.isLoading = false
        })
    },
    gerarCodigos() {
      this.isLoading = true
      let obras = []
      if (this.obra.length > 0) {
        obras = this.obra.map((obra) => obra.value)
      }
      estoqueService
        .listByDate(
          this.dataInicial,
          this.dataFinal,
          obras,
          this.$store.state.filter,
          this.$store.state.filial,
          true
        )
        .then(async (res) => {
          const { data } = res.data

          this.estoqueCodigosExcel = data
          this.itemsCodigos = this.estoqueCodigosExcel

          this.$bvModal.show('rel-estoque')
          this.isLoading = false
        })
        .catch((err) => {
          this.errorMessage(err.message)
          this.isLoading = false
        })
    },
    formatDate(date) {
      if (date) {
        return moment.utc(date).format('DD/MM/YYYY')
      } else {
        return ' '
      }
    },
    async generateReport() {
      if (this.tipoRelatorio === 'codigos') {
        await this.$refs.html2Pdf2.generatePdf()
      } else {
        await this.$refs.html2Pdf.generatePdf()
      }
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      const vue = this
      if (this.isSignature) {
        await html2pdf()
          .set(options)
          .from(pdfContent)
          .toPdf()
          .output('datauristring')
          .then(function (pdfAsString) {
            vue.signRevenue(pdfAsString)
          })
        return
      }
      this.isLoading = true
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          vue.isLoading = false
        })
        .save()
    },
  },
}
</script>
<style src="../style.scss" lang="scss"></style>
<style >
.div-estoque {
  min-width: 10vw;
}

.div-descricao {
  min-width: 12vw;
}

@media (min-width: 992px) {
  .modal .modal-huge {
    max-width: 90% !important;
    width: 90% !important;
  }
}
</style>
